<template>
  <v-row>
    <v-col cols="12">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        max-width="290"
      >
        <template v-slot:activator="{ on, attrs }">
          <div class="input-group">
            <input
              :id="id"
              type="text"
              class="form-control"
              aria-describedby="basic-addon2"
              :placeholder="placeholder"
              :value="computedDateFormattedMomentjs"
              @change="(val) => onChange(val)"
              v-bind="attrs"
              v-on="on"
              :class="{ 'input--error': validate }"
              :disabled="setDisable"
            />
          </div>
        </template>
        <v-date-picker
          v-model="date"
          :no-title="true"
          event-color="green lighten-1"
          @change="(val) => onChange(val)"
          :locale="lang"
          :active-picker.sync="pickerActive"
          :min="minDate"
          :max="maxDate"
          :allowed-dates="allowedDates"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";

export default {
  name: "date-picker",
  props: {
    value: {
      type: String,
      default: () => moment().format("YYYY-MM-DD"),
    },
    lang: {
      type: String,
      default: "th",
    },
    format: {
      type: String,
      default: "D MMM YY",
    },
    placeholder: {
      type: String,
      default: "กรุณาเลือกวันที่",
    },
    activePicker: {
      type: String,
      default: "DATE",
    },
    validate: {
      type: Boolean,
      default: () => false,
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    allowedDates: {
      type: Function,
      default: null,
    },
    setDisable: {
      type: Boolean,
    },
    id: {
      type: String,
      default: "",
    },
  },
  mounted() {
    if (this.value) {
      this.date = this.value;
    }
  },
  computed: {
    computedDateFormattedMomentjs() {
      if (this.date) {
        if (this.lang === "th") {
          const christianYear = Number.parseInt(this.date.split("-")[0]);
          const thaiYear = (Number.parseInt(christianYear) + 543).toString();
          return moment(String(this.date))
            .locale("th")
            .format(
              this.format
                .replace("YYYY", thaiYear)
                .replace("YY", thaiYear.substring(2, 4))
            )
            .replace(christianYear.toString(), thaiYear);
        } else {
          return moment(String(this.date)).locale("en").format(this.format);
        }
      } else {
        return "";
      }
    },
    setCurrentShow() {
      let dateCurr = this.showCurrent;
      let value = this.showCurrent;
      this.$emit("change", value);
      return dateCurr;
    },
  },
  data() {
    return {
      date: null,
      menu: false,
      pickerActive: "",
    };
  },

  methods: {
    onClick(data) {
      this.$emit("updated", data);
    },
    onChange(value) {
      this.menu = false;
      this.$emit("change", value);
    },
  },
  watch: {
    value: {
      handler: function (val) {
        this.date = val || "";
      },
      deep: true,
    },
    menu(val) {
      val && setTimeout(() => (this.pickerActive = this.activePicker));
    },
  },
};
</script>

<style lang="scss">
.input-group {
  .input--error {
    border-color: red !important;
  }
}
</style>
